import {
  getQRI,
  hasCodeProperty,
  hasNameProperty,
  QualityEventResource,
  QriDetailsV2,
  ResourceDomainParser,
} from '@qualio/search-qri';
import { SearchResource } from '@qualio/ui-components';
import { QualityEventDetailsResponse } from '../types';
import type { ResourceSelectItem } from '../components/EventModal/components/MultiSelectWithSuggestions';
import { getQriServiceUrl } from './qriServiceUrl';

const getQriDomain = () => process.env.REACT_APP_QRI_DOMAIN_OVERRIDE ?? getQriServiceUrl();

const buildEventQri = (companyId: number, eventId: number) =>
  getQRI({
    domain: ResourceDomainParser.enum['quality-events'],
    domainType: QualityEventResource.enum['quality-event'],
    companyId: String(companyId),
    id: String(eventId),
    qriBaseUrl: getQriDomain(),
  });

const extractRelatedQrisFromQueryEventData = (eventData?: QualityEventDetailsResponse) => {
  if (!eventData) {
    return [];
  }
  const suppliers = eventData.issue.suppliers ?? [];
  const relatedDocuments = eventData.issue.related_documents ?? [];
  const relatedEvents = eventData.issue.related_events ?? [];
  return [...suppliers, ...relatedDocuments, ...relatedEvents];
};

const qriDetailsAsSelectData = (data: QriDetailsV2[]): ResourceSelectItem[] => {
  return data
    .map((item): ResourceSelectItem | undefined => {
      const code = hasCodeProperty(item) ? item.identifiers.code ?? undefined : undefined;
      const resource = 'resource' in item ? (item.resource as SearchResource) : undefined;
      if (hasNameProperty(item)) {
        return { value: item.identifiers.qri, label: item.name, code, title: item.name, resource };
      }
      return undefined;
    })
    .filter((val): val is ResourceSelectItem => val !== undefined);
};

export { buildEventQri, extractRelatedQrisFromQueryEventData, qriDetailsAsSelectData };
